import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google';
import { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { CookiesPopup } from '@r-and-a-shared-ui/common-ui';
import { getWebsiteStructuredData } from '@r-and-a-shared-ui/utils';
import useSchemaOrg from '../../hooks/useSchemaOrg';
import {
  cookie_settings,
  cookie_popup,
} from 'libs/core-data-mapping/src/lib/kontent_ai_mapping';

export const MembershipConfiguration = ({
  siteSettings,
}: {
  siteSettings?: MEMBERSHIP_MODELS.MembershipConfiguration | any;
}) => {
  useSchemaOrg(getWebsiteStructuredData());

  if (!siteSettings) {
    return null;
  }

  const cookieSettings = cookie_settings(
    siteSettings.elements?.cookie_settings?.linkedItems?.[0],
  );
  const cookiesPopup = cookie_popup(
    siteSettings.elements?.cookie_popup?.linkedItems?.[0],
  );

  return (
    <>
      {cookieSettings && (
        <>
          <GoogleTagManager gtmId={cookieSettings.performanceCookiesGTMID || ''} />
          <GoogleAnalytics gaId={cookieSettings.performanceCookiesGAID || ''} />
        </>
      )}

      {cookiesPopup && cookieSettings && (
        <CookiesPopup
          cookiesPopup={cookiesPopup}
          cookiesSettings={cookieSettings}
        />
      )}
    </>
  );
};
